import {
  Checkbox, TableCell, TableHead, TableRow
} from '@mui/material';
import React, { FC, useContext } from 'react';
import { WbTableContext } from './WbTable';

interface WbTableHeadProps {
  children: any;
}

export const WbTableHead: FC<WbTableHeadProps> = ({children}) => {
  const {allItemsSelected, hasSelectedItems, selectAllItems} = useContext(WbTableContext)

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            checked={allItemsSelected}
            indeterminate={hasSelectedItems && !allItemsSelected}
            onChange={(_, checked) => selectAllItems(checked)}
          />
        </TableCell>
        {React.Children.map(children, (child) => React.cloneElement(child))}
        <TableCell/>
      </TableRow>
    </TableHead>
  );
};
